<template>
  <div class="w-full h-full flex justify-center items-center">
    <div :class="[
        `size-${size}`,
        'grm-loading-circle border-4 rounded-full'
    ]"></div>
  </div>
</template>

<script>
export default {
  name: 'GrmLoadingCircle',
  props: {
    size: { type: String, default: 'md' }
  }
}
</script>

<style lang="scss" scoped>
.size-{
  &xs { @apply w-4 h-4 }
  &sm { @apply w-6 h-6 }
  &md { @apply w-8 h-8 }
}
.grm-loading-circle {
  border-color: rgba(#59f, 0.5);
  border-top-color: rgba(#59f, 1);
  animation: spin 1s infinite cubic-bezier(0.65, 0, 0.35, 1);
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(359deg); }
}
</style>